// breakwater-fe/src/reducers/commentReducer.js
import {
  LOAD_COMMENTS, LOAD_COMMENTS_SUCCESS, LOAD_COMMENTS_FAIL,
  CREATE_COMMENT_SUCCESS, UPDATE_COMMENT_SUCCESS, DELETE_COMMENT_SUCCESS
} from '../actions/CommentActions';

const initialSlice = { loading: false, error: null, comments: [] };

export default function commentReducer(state = { byParent: {} }, action) {
  const pk = action.parentKey;
  const slice = pk ? (state.byParent[pk] || initialSlice) : null;

  switch (action.type) {
    case LOAD_COMMENTS:
      return { byParent: { ...state.byParent, [pk]: { ...slice, loading: true, error: null } } };
    case LOAD_COMMENTS_SUCCESS:
      return { byParent: { ...state.byParent, [pk]: { ...slice, loading: false, comments: action.comments } } };
    case LOAD_COMMENTS_FAIL:
      return { byParent: { ...state.byParent, [pk]: { ...slice, loading: false, error: action.error } } };
    case CREATE_COMMENT_SUCCESS:
      return { byParent: { ...state.byParent, [pk]: { ...slice, comments: [action.comment, ...slice.comments] } } };
    case UPDATE_COMMENT_SUCCESS:
      return { byParent: { ...state.byParent, [pk]: {
        ...slice,
        comments: slice.comments.map(c => c.id === action.comment.id ? action.comment : c)
      } } };
    case DELETE_COMMENT_SUCCESS:
      return { byParent: { ...state.byParent, [pk]: {
        ...slice,
        comments: slice.comments.filter(c => c.id !== action.commentId)
      } } };
    default:
      return state;
  }
}
